type DeploymentType = 'CI' | 'COMMUNITY_SOLAR' | 'UTILITY';

export const DeploymentTypes = {
  CI: 'CI' as DeploymentType,
  COMMUNITY_SOLAR: 'COMMUNITY_SOLAR' as DeploymentType,
  UTILITY: 'UTILITY' as DeploymentType
};

export const DeploymentTypeDisplay = {
  [DeploymentTypes.CI]: 'Commercial or industrial',
  [DeploymentTypes.COMMUNITY_SOLAR]: 'Community solar',
  [DeploymentTypes.UTILITY]: 'Utility'
};

export const DeploymentTypeShortDisplay = {
  [DeploymentTypes.CI]: 'C & I',
  [DeploymentTypes.COMMUNITY_SOLAR]: 'Community solar',
  [DeploymentTypes.UTILITY]: 'Utility'
} as const;

export const DeploymentTypeRadioOptions = [
  {
    value: DeploymentTypes.CI,
    label: DeploymentTypeDisplay[DeploymentTypes.CI]
  },
  {
    value: DeploymentTypes.COMMUNITY_SOLAR,
    label: DeploymentTypeDisplay[DeploymentTypes.COMMUNITY_SOLAR]
  },
  {
    value: DeploymentTypes.UTILITY,
    label: DeploymentTypeDisplay[DeploymentTypes.UTILITY]
  }
];

export const DeploymentTypeDropdownOptions = [
  {
    value: DeploymentTypes.CI,
    text: DeploymentTypeDisplay[DeploymentTypes.CI]
  },
  {
    value: DeploymentTypes.COMMUNITY_SOLAR,
    text: DeploymentTypeDisplay[DeploymentTypes.COMMUNITY_SOLAR]
  },
  {
    value: DeploymentTypes.UTILITY,
    text: DeploymentTypeDisplay[DeploymentTypes.UTILITY]
  }
];